import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api'

/**
 * Sentry + Grafana Loki quota burn — Pillar C.
 *
 * Backed by `GET /api/health/quota` (see `apps/api/src/routes/health-quota.ts`).
 * Server-side cache is 10 minutes; matches `staleTime` here. Status is one of
 * `ok | warn | critical | unknown` — the latter when credentials are missing
 * or the upstream probe failed (`error` field populated).
 */

export type QuotaStatus = 'ok' | 'warn' | 'critical' | 'unknown'

export interface QuotaField {
  used?: number
  limit?: number
  pct?: number
  status: QuotaStatus
  error?: string
}

export interface QuotaHealthData {
  sentry: QuotaField
  grafana_logs_gb: QuotaField
  fetchedAt: string
}

export const quotaHealthQueryKey = ['health', 'quota'] as const

export function useQuotaHealth() {
  return useQuery({
    queryKey: quotaHealthQueryKey,
    queryFn: () => api.get<QuotaHealthData>('/health/quota'),
    staleTime: 10 * 60 * 1000,
    retry: 1,
  })
}
